import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=e6da48da&"
import script from "./Arrow.vue?vue&type=script&lang=ts&"
export * from "./Arrow.vue?vue&type=script&lang=ts&"
import style0 from "./Arrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports